import { useEffect, useState } from "react";
import { CiMail } from "react-icons/ci";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import logo from "../../assets/logo-2.png";
import SelectField from "../ui/SelectField";
import { PhoneNumber } from "../ui/PhoneNumber";
import Input from "../ui/Input";
import { USER_TYPE, USERS_LIST, userType } from "../../helper/constant";
import { validEmail } from "../../helper/appConstant";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  checkEmailOrPhoneNumberExistOrNot,
  login,
  socialLogin,
} from "../../store/slice/auth";
import ConfirmationDialog from "../dialogs/ConfirmationDialog";
import { useGoogleLogin } from "@react-oauth/google";
import googleIcon from "../../assets/google.png";
import AuthRightSection from "./AuthRightSection";
import UserTypeDialog from "../dialogs/UserTypeDialog";
import Button from "component/ui/Button";
import secureLocalStorage from "react-secure-storage";
import Cookies from "js-cookie";
export default function LoginPage() {
  const navigate = useNavigate("");
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [focusedInput, setFocusedInput] = useState(null);
  const [loginType, setLoginType] = useState("phone");
  const [formData, setFormData] = useState({});
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState({});
  const [userTypeDialogOpen, setUserTypeDialogOpen] = useState(false);
  const [userTypeData, setUserTypeData] = useState(userType);
  const { userExistingRoles } = useSelector((state) => state.auth);
  const [socialData, setSocialData] = useState({});
  const fcmToken = secureLocalStorage.getItem(
    process.env.REACT_APP_FCM_TOKEN_KEY
  )
    ? secureLocalStorage.getItem(process.env.REACT_APP_FCM_TOKEN_KEY)
    : Cookies.get(process.env.REACT_APP_FCM_TOKEN_KEY);

  useEffect(() => {
    if (userExistingRoles && userExistingRoles?.length > 0) {
      setUserTypeDisable();
    } else {
      let data = [...userTypeData];
      data.map((item, index) => {
        data[index].disable = true;
      });
      setUserTypeData(data);
    }
  }, [userExistingRoles]);

  const setUserTypeDisable = () => {
    let data = [...userTypeData];
    console.log(userExistingRoles, "userExistingRoles", data);
    data.map((item, index) => {
      if (!userExistingRoles?.includes(item?.id)) {
        data[index].disable = true;
      } else {
        data[index].disable = false;
      }
    });
    setUserTypeData(data);
  };

  const verifyPhoneEmail = () => {
    const data = {
      email: formData?.email || "",
      phoneNumber: formData?.phoneNumber || "",
      countryCode: formData?.phoneNumber ? formData?.countryCode : "",
    };
    dispatch(checkEmailOrPhoneNumberExistOrNot(data));
  };

  const handleLogin = (e) => {
    if (loginType == "email" && !formData?.email) {
      setFormData(() => ({
        ...formData,
        emailError: "Please enter email.",
      }));
      return;
    }
    if (
      loginType == "email" &&
      formData?.email &&
      !validEmail(formData?.email)
    ) {
      // setEmailError('Please enter valid email.');
      setFormData(() => ({
        ...formData,
        emailError: "Please enter valid email.",
      }));
      return;
    }
    if (loginType == "phone" && !formData?.phoneNumber) {
      setFormData(() => ({
        ...formData,
        phoneError: "Please enter phone number.",
      }));
      return;
    }
    if (!formData?.userType) {
      setFormData(() => ({
        ...formData,
        userTypeError: "Please select user type.",
      }));
      return;
    }
    if (!formData?.password) {
      setFormData(() => ({
        ...formData,
        passwordError: "Please enter password.",
      }));
      return;
    }
    if (formData?.password && formData?.password.length < 8) {
      setFormData(() => ({
        ...formData,
        passwordError: "Password must be minumum 8 characters.",
      }));
      return;
    }

    const data = {
      email: loginType == "email" ? formData?.email : "",
      password: formData?.password,
      deviceToken: fcmToken,
      deviceType: "web",
      phoneNumber: loginType == "phone" ? formData?.phoneNumber : "",
      countryCode: loginType == "phone" ? formData?.countryCode : "",
      userType: formData?.userType,
    };
    dispatch(login(data, navigate, setIsDialogOpen));
  };

  const handleForgetPassword = () => {
    navigate("/forgot-password");
  };

  const loginGoogle = useGoogleLogin({
    flow: "implicit", // ensures you get the access token
    scope: "openid email profile",
    onSuccess: async (tokenResponse) => {
      // Fetch user info using the access token
      try {
        const res = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        const user = await res.json();
        setSocialData(() => ({
          ...socialData,
          socialAccessToken: tokenResponse.access_token,
          user: user,
          socialId: user.sub,
        }));
        onSocialLogin(tokenResponse.access_token, user, user.sub);
      } catch (err) {
        console.error("Failed to fetch user info", err);
      }
    },
    onError: (err) => {
      console.error("Login Failed:", err);
    },
  });

  const onSocialLogin = (socialAccessToken, user, socialId) => {
    const data = {
      fullName: user?.name,
      email: user?.email,
      deviceToken: fcmToken,
      socialAccessToken: socialAccessToken,
      socialId: socialId,
      userType: formData?.userType || null,
      diviceType: "WEB",
    };

    dispatch(
      socialLogin(
        data,
        setUserTypeDialogOpen,
        verifyPhoneEmail,
        navigate,
        setIsDialogOpen
      )
    );
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 flex items-center justify-center p-4">
      <div className="container w-full mx-auto rounded-md flex overflow-hidden bg-white">
        {/* Left Section */}
        <AuthRightSection />

        {/* Right Section */}
        <div className="w-full md:p-5 p-3 md:w-1/2 flex flex-col justify-center bg-white relative overflow-hidden">
          <div className="w-full mx-auto">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2BACE2] via-[#057BB5] to-[#2BACE2]"></div>

            <div className="mb-5 flex justify-center animate-fade-in">
              <img src={logo} alt="Logo" className="w-48" />
            </div>

            <h2 className="text-3xl font-bold text-gray-800 text-center">
              Welcome Back
            </h2>
            <p className="text-gray-500 text-sm mt-2 text-center mb-2">
              Please login to continue to your account
            </p>

            <div className="flex justify-center mb-4">
              {loginType === "phone" ? (
                <button
                  onClick={() => setLoginType("email")}
                  className="text-[#2BACE2] text-sm font-semibold hover:underline"
                >
                  Login with your Email
                </button>
              ) : (
                <button
                  onClick={() => setLoginType("phone")}
                  className="text-[#2BACE2] text-sm font-semibold hover:underline"
                >
                  Login with your Phone
                </button>
              )}
            </div>

            {loginType === "phone" && (
              <div className="space-y-4">
                <div>
                  <PhoneNumber
                    countrySelectorStyleProps={{
                      buttonStyle: {
                        width: "32px",
                        height: "40px",
                        padding: "0 4px",
                      },
                      flagStyle: { width: "16px" },
                    }}
                    placeholder="Phone number"
                    onBlur={() => {
                      verifyPhoneEmail();
                    }}
                    onChange={(val) =>
                      setFormData(() => ({
                        ...formData,
                        ...val,
                        phoneError: "",
                      }))
                    }
                    error={formData?.phoneError}
                  />
                </div>
              </div>
            )}

            {loginType === "email" && (
              <div className="space-y-4">
                <div className="relative group">
                  <Input
                    onFocus={() => setFocusedInput("email")}
                    onBlur={() => {
                      setFocusedInput(null);
                      verifyPhoneEmail();
                    }}
                    placeholder="your.email@example.com"
                    inputClassName="w-full pl-4 pr-12 py-3 placeholder:text-sm text-sm transition-all duration-300 bg-gray-50 hover:bg-white relative  "
                    onChange={(val) =>
                      setFormData(() => ({
                        ...formData,
                        email: val,
                        emailError: "",
                      }))
                    }
                    error={formData?.emailError}
                  />
                  <div
                    className={`absolute right-4 top-1/2 -translate-y-1/2 ${
                      focusedInput === "email"
                        ? "text-[#2BACE2]"
                        : "text-gray-400"
                    }`}
                  >
                    <CiMail size={20} />
                  </div>
                </div>
              </div>
            )}

            <div className="mt-4">
              <SelectField
                placeholder="I am signing as a..."
                value={formData?.userType ? formData?.userType : ""}
                id="my-select"
                options={userType}
                onChange={(val) =>
                  setFormData(() => ({
                    ...formData,
                    userType: val,
                    userTypeError: "",
                  }))
                }
                focusedInput={focusedInput}
                setFocusedInput={setFocusedInput}
                error={formData?.userTypeError}
              />
            </div>

            <div className="space-y-4 mt-4">
              <div className="relative group">
                <div className="relative">
                  <Input
                    type={showPassword ? "text" : "password"}
                    onFocus={() => setFocusedInput("password")}
                    onBlur={() => setFocusedInput(null)}
                    placeholder="Enter password"
                    inputClassName="w-full pl-4 pr-12 py-3 placeholder:text-sm text-sm transition-all duration-300 bg-gray-50 hover:bg-white relative  "
                    onChange={(val) =>
                      setFormData(() => ({
                        ...formData,
                        password: val,
                        passwordError: "",
                      }))
                    }
                    error={formData?.passwordError}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className={`absolute right-4 top-1/2 -translate-y-1/2 ${
                      focusedInput === "password"
                        ? "text-[#2BACE2]"
                        : "text-gray-400"
                    }`}
                  >
                    {showPassword ? (
                      <IoEyeOutline size={20} />
                    ) : (
                      <IoEyeOffOutline size={20} />
                    )}
                  </button>
                </div>
              </div>

              <div className="flex justify-end -mt-2">
                <a
                  onClick={handleForgetPassword}
                  className="text-[#2BACE2] text-sm font-semibold cursor-pointer relative group"
                >
                  Forgot Password?
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#2BACE2] group-hover:w-full transition-all duration-300"></span>
                </a>
              </div>

              <div className="flex justify-center pt-2">
                <Button className="w-full" onClick={handleLogin}>
                  Log In
                </Button>
              </div>
            </div>

            <div className="flex justify-center">
              <p className="mt-3 text-sm text-gray-600">
                Don't have an account?{" "}
                <a
                  className="text-[#2BACE2] font-semibold relative group"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/signup")}
                >
                  Sign Up
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#2BACE2] group-hover:w-full transition-all duration-300"></span>
                </a>
              </p>
            </div>

            <div className="relative my-4">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-200"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="px-4 bg-white text-gray-500">
                  Or continue with
                </span>
              </div>
            </div>

            <div className="flex justify-center gap-6 pb-2">
              <button
                className="flex items-center justify-center gap-2 px-4 py-2 bg-white text-[#2BACE2] border border-[#2BACE2] font-semibold rounded-full shadow-lg transform transition duration-300 hover:bg-[#e8f2ff] active:scale-95"
                onClick={() => loginGoogle()}
              >
                <img src={googleIcon} alt="google" width={"30px"} />
                <span>Sign in with Google</span>
              </button>
              {USERS_LIST?.length > 0 && (
                <button
                  onClick={() => setIsDropdownOpen(true)}
                  className="flex items-center justify-center gap-2 px-4 py-2 bg-white text-[#2BACE2] border border-[#2BACE2] font-semibold rounded-full shadow-lg transform transition duration-300 hover:bg-[#e8f2ff] active:scale-95"
                >
                  <span>Use a saved accounts</span>
                </button>
              )}
            </div>
          </div>
        </div>
        {/* accounts listing dialog */}
        {isDropdownOpen && (
          <div
            className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50"
            onClick={() => setIsDropdownOpen(false)}
          >
            <div
              className="bg-white py-5  rounded-lg w-96 shadow-lg"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="">
                {USERS_LIST?.map((account, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      secureLocalStorage.setItem(
                        process.env.REACT_APP_TOKEN_STORAGE_KEY,
                        account?.token
                      );
                      secureLocalStorage.setItem(
                        process.env.REACT_APP_USER_STORAGE_KEY,
                        account?.data
                      );
                      navigate("/");
                      window.location.reload();
                    }}
                    className="w-full p-3 border-b flex items-center gap-3 p-2 rounded-lg hover:bg-slate-100 transition-colors mb-1 last:mb-0"
                  >
                    <div
                      style={{
                        backgroundImage:
                          account?.data?.venueImageUrl?.length > 0
                            ? `url("${
                                account?.data?.venueImageUrl?.length > 0 &&
                                account?.data?.venueImageUrl[0]
                              }")`
                            : "",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                      }}
                      className={`w-12 h-12 rounded bg-brand-gradient rounded-full flex items-center justify-center text-white text-xs font-bold`}
                    >
                      {account?.data?.venueImageUrl?.length > 0
                        ? ""
                        : account?.data?.name &&
                          account?.data?.name[0]?.toUpperCase()}
                    </div>
                    <div className="text-left">
                      <div>
                        <p className="text-sm font-semibold text-slate-800">
                          {account?.data?.name}{" "}
                          <span className="font-light text-sm">{`(${
                            USER_TYPE[account?.data?.userType]
                          })`}</span>
                        </p>
                        <p className="text-sm text-slate-800">
                          {account?.data?.email}
                        </p>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}
        {/* Dialogs remain outside the form wrapper but inside the flex container */}
        <ConfirmationDialog
          isDialogOpen={isDialogOpen}
          buttonShow={["OK"]}
          closeDialog={() => {
            setIsDialogOpen(false);
          }}
        />
        {userTypeDialogOpen && (
          <UserTypeDialog
            closeDialog={() => {
              setUserTypeDialogOpen(false);
            }}
            loginGoogle={() => {
              setUserTypeDialogOpen(false);
              onSocialLogin(
                socialData.socialAccessToken,
                socialData.user,
                socialData.socialId
              );
            }}
            userTypeData={userTypeData}
            setFormData={setFormData}
            formData={formData}
          />
        )}
      </div>
    </div>
  );
}
